export default "__VITE_ASSET__Bx97E$k6__$_?nuxt_component=async&nuxt_component_name=IconFunctionIconsMinimizer&nuxt_component_export=default__"